import React from 'react';
import templates from './templates';
import './TextWidget.css';

export const TEXT_WIDTH = 500;
export const TEXT_HEIGHT = 350;

export const TextWidget = ({ text = "לחץ לשינוי הטקסט", onSave, template = 'Fixed' }) => {
  const Template = templates[template];

  if (!Template) {
    console.error('Template not found:', template, 'Available:', Object.keys(templates));
    return <div>Template not found: {template}</div>;
  }

  return (
    <Template
      text={text}
      onSave={onSave}
      FIXED_TEXT_WIDTH={TEXT_WIDTH}
      FIXED_TEXT_HEIGHT={TEXT_HEIGHT}
    />
  );
};